import React from "react"
import Typography from '@mui/material/Typography';


export const SourcesCardio = () => {

return(
<div>

<Typography component="span" variant="h5" sx={{fontWeight: '700'}}>Sources: </Typography>
<br /> <br />
https://www.ncbi.nlm.nih.gov/gtr/tests/597179/ <br /> 
https://www.ncbi.nlm.nih.gov/gtr/tests/591956/ <br /> 

</div>
)
}